import React, { useImperativeHandle, useState } from 'react';

export interface AsyncDialogRef<D = any, R = any> {
  show: (data?: D) => Promise<R>;
}

export interface IAsyncDialogProps<D = any, OKR = any, CR = any> {
  data?: D;
  open: boolean;
  onClose: (value?: CR) => void | Promise<void>;
  onOk: (reason?: OKR) => void | Promise<void>;
}

interface AsyncDialogProps<D = any, OKR = any, CR = any> {
  dialog: (props: IAsyncDialogProps<D, OKR, CR>) => React.JSX.Element;
}

type PromiseInfo = {
  resolve: (value?: any) => void;
  reject: (reason?: any) => void;
};

export const AsyncDialog = React.forwardRef<AsyncDialogRef, AsyncDialogProps>((props, ref) => {
  const [promiseInfo, setPromiseInfo] = useState<PromiseInfo | null>(null);
  const [data, setData] = useState<any>(null);
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    show: (initialData?: any) =>
      new Promise((resolve, reject) => {
        setPromiseInfo({ resolve, reject });
        setData(initialData);
        setOpen(true);
      }),
  }));

  const onOk = (value?: any) => {
    promiseInfo?.resolve(value);
    setOpen(false);
  };

  const onClose = (reason?: any) => {
    promiseInfo?.reject(reason);
    setOpen(false);
  };

  return <props.dialog {...props} data={data} open={open} onClose={onClose} onOk={onOk} />;
});
